const PENDING_VERSION_KEY = 'tocin-web-pending-version'
const VERSION_CHECK_INTERVAL = 60 * 1000

function getAppAsset (value) {
  const match = String(value || '').match(/(?:^|\/)js\/(app\.[a-f0-9]+\.js)(?:\?|$)/i)
  return match ? match[1] : ''
}

function getLoadedAppAsset () {
  return Array.from(document.scripts)
    .map(script => getAppAsset(script.src))
    .find(Boolean) || ''
}

function getLatestAppAsset (html) {
  const match = String(html || '').match(/(?:src=["'])([^"']*\/js\/app\.[a-f0-9]+\.js(?:\?[^"']*)?)["']/i)
  return match ? getAppAsset(match[1]) : ''
}

function isPaymentFlowRoute (path) {
  return /^\/member\/shopcart\/step\/[2-5](?:\/|$)/.test(path || '')
}

export function initAppVersionUpdater (router) {
  if (process.env.NODE_ENV !== 'production') {
    return
  }

  let checking = false

  const reloadForUpdate = () => {
    sessionStorage.removeItem(PENDING_VERSION_KEY)
    window.location.reload()
  }

  const checkVersion = async () => {
    if (checking) {
      return
    }

    const loadedAsset = getLoadedAppAsset()
    if (!loadedAsset) {
      return
    }

    const currentPath = router.currentRoute && router.currentRoute.path
    const pendingAsset = sessionStorage.getItem(PENDING_VERSION_KEY)
    if (pendingAsset === loadedAsset) {
      sessionStorage.removeItem(PENDING_VERSION_KEY)
    } else if (pendingAsset && !isPaymentFlowRoute(currentPath)) {
      reloadForUpdate()
      return
    }

    checking = true
    try {
      const response = await window.fetch(`/index.html?app_version=${Date.now()}`, {
        cache: 'no-store',
        credentials: 'same-origin',
        headers: {
          'Cache-Control': 'no-cache'
        }
      })
      if (!response.ok) {
        return
      }

      const latestAsset = getLatestAppAsset(await response.text())
      if (!latestAsset || latestAsset === loadedAsset) {
        return
      }

      sessionStorage.setItem(PENDING_VERSION_KEY, latestAsset)
      if (!isPaymentFlowRoute(currentPath)) {
        reloadForUpdate()
      }
    } catch (error) {
      // 版本檢查失敗不影響使用者目前操作，稍後會再次檢查。
    } finally {
      checking = false
    }
  }

  router.afterEach(() => {
    window.setTimeout(checkVersion, 0)
  })

  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') {
      checkVersion()
    }
  })

  window.setInterval(checkVersion, VERSION_CHECK_INTERVAL)
  checkVersion()
}
